/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

// Used to generate the requirejs layers bundle
// Only declare the entry points, not all modules!
define([
	'./content/common/formatAction/FormatAction',
	'./content/dataQueryExecution/QueryProvider',
	'./content/dataQueryExecution/QueryDefinitionProvider',
	'./content/dataQueryExecution/QueryDefinitionModifier',
	'./content/dataQueryExecution/DetailQueryProvider',
	'./content/dataQueryExecution/QueryDataItemBuilder',
	'./content/dataQueryExecution/QueryModifier',
	'./content/dataQueryExecution/DataQueryUtils',
	'./content/dataQueryExecution/DataQueryExecution',
	'./content/dataQueryExecution/QueryResults',
	'./content/dataQueryExecution/DataQueryResult',
	'./content/dataQueryExecution/DataQueryResultItem',
	'./content/dataQueryExecution/QueryDefinitionProvider',
	'./content/dataQueryExecution/SummaryQueryModifier',
	'./content/dataQueryExecution/SummaryQueryProvider',
	'./content/dataQueryExecution/V2QueryDefinitionModifier',
	'./content/dataQueryExecution/api/DataQueryExecutionAPI',
	'./content/dataQueryExecution/api/QueryDefinitionProviderAPI',
	'./content/dataQueryExecution/api/QueryDefinitionModifierAPI',
	'./content/dataQueryExecution/api/QueryProviderAPI',
	'./content/dataQueryExecution/api/QueryResultsAPI',
	'./content/dataQueryExecution/api/QueryModifierAPI',
	'./content/dataQueryExecution/api/SummaryQueryModifierAPI',
	'./content/slotActions/autoBinAction/BinAction',
	'./content/layers',
	'./content/slotActions/aggregationTypeAction/AggregationTypeAction',
	'./content/slotActions/sortAction/SortAction',
	'./content/slotActions/sortAction/CustomSortAction',
	'./content/slotActions/deleteAction/DeleteAction',
	'./content/slotActions/topBottomAction/TopBottomAction',
	'./content/slotActions/filterAction/FilterAction',
	'./content/slotActions/removeShapeAction/RemoveShapeAction',
	'./content/slotActions/topKeyDriversAction/TopKeyDriversAction',
	'./content/dataPointActions/hideRowColumnAction/HideRowColumnAction',
	'./content/dataPointActions/filterAction/DataPointFilterAction',
	'./content/dataPointActions/drillAction/DrillAction',
	'./content/developerWidgetRefreshAction/DeveloperWidgetRefreshAction',
	'./content/dataQueryExecution/CrosstabQueryDefinitionModifier',
	'./widget/conditionalFormat/api/DeprecatedConditionalFormatAPI',
	'./widget/deprecatedVisAPI/api/Deprecated_VisAPI',
	'./widget/hierarchyDrillAction/api/HierarchyDrillActionAPI',
	'./widget/smartRecommender/api/SmartRecommenderAPI',
	'./widget/predictService/api/PredictServiceAPI',
	'./widget/layers',
	'../datatray/layers',
	'./dashboard/layers',
	'./dashboard/customViz/CustomVizService',
	'./dashboard/fredIsRed/api/FredIsRedAPI',
	'./dashboard/queryService/QueryResultColumn',
	'./dashboard/queryService/QueryService',
	'./dashboard/queryService/QueryService2',
	'./dashboard/queryService/InternalQueryService',
	'./dashboard/queryService/ResultItem',
	'./dashboard/queryService/QueryResultData',
	'./dashboard/queryService/Query',
	'./dashboard/queryService/QueryDataItemSet',
	'./dashboard/queryService/QueryDefinition',
	'./dashboard/queryService/api/QueryAPI',
	'./dashboard/queryService/api/QueryAPI2',
	'./dashboard/queryService/api/QueryDefinitionAPI',
	'./dashboard/queryService/api/QueryServiceAPI',
	'./dashboard/queryService/api/QueryService2API',
	'./dashboard/queryService/api/InternalQueryServiceAPI',
	'./dashboard/queryService/api/QueryResultAPI',
	'./dashboard/queryService/api/ResultItemAPI',
	'./dashboard/visDefinitions/api/impl/VisDefinitions',
	'./dashboard/visDefinitions/api/VisDefinitionsAPI',
	'./dashboard/globalFilters/GlobalFilters',
	'./dashboard/globalFilters/api/GlobalFiltersAPI',
	'./dashboard/recommender/api/InternalRecommenderAPI',
	'./dashboard/recommender/InternalRecommender',
	'./dashboard/prompts/Prompts',
	'./dashboard/prompts/controls/DateTimePromptView',
	'./dashboard/prompts/controls/InputPromptView',
	'./dashboard/prompts/controls/RangePromptView',
	'./dashboard/prompts/controls/SearchAndSelectPromptView',
	'./dashboard/prompts/api/PromptsAPI',
	'./dashboard/actions/SearchAction',
	'./dashboard/icons/LiveWidgetIconsProvider',
	'./dashboard/actions/filterDock/FilterDockAction',
	'./dashboard/actions/filterDock/ActiveFilterView',
	'../extensions/layers'
], () => {});
